module.exports = __webpack_public_path__ + "img/zhang.33d340be.png";